'use client'
import React from 'react'
import { t } from 'i18next'
import Button from 'app/app/(client)/components/atoms/Button/Button'
import { Customer } from 'app/app/(client)/components/templates/Customer/Customer'
import Shimmer from '../Customer/Shimmer'
import NoSearchResults from '../../molecules/NoSearchResults/NoSearchResults'
import NoData from '../../molecules/NoData/NoData'
import { CustomerModel, OpportunitiesProps } from 'app/types/ui/opportunity'
import { capitalizeIfEnglish } from 'app/app/(client)/utils/utils'

const SharedOpportunities: React.FC<OpportunitiesProps> = ({ customers, dataStatus, onOpportunityDialogUpdate }) => {
  if (dataStatus === 'loading' || dataStatus === 'idle') {
    return <Shimmer />
  }

  if (dataStatus === 'failed') {
    return null
  }

  if (!customers) {
    return (
      <NoData noDataText={t('customers.noSharedOpportunities')}>
        <Button
          id={`shared-opportunity-tab-import-button`}
          onClick={() => onOpportunityDialogUpdate && onOpportunityDialogUpdate(true)}
          variant="primary"
          size="small"
          className="btn"
        >
          {capitalizeIfEnglish(t('customers.import'))}
        </Button>
      </NoData>
    )
  }

  if (customers.length === 0) {
    return <NoSearchResults />
  }

  return (
    <div className="flex flex-col gap-3 md:gap-6 items-center mt-5">
      {customers.map((customerValue: CustomerModel, index: number) => (
        <Customer key={index} {...customerValue} />
      ))}
    </div>
  )
}

export default React.memo(SharedOpportunities)
